export const invisiblestring = "⠀";
export const averageString = "⌀";
export const daysFactor = 86400000;

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const header = {
   "Content-type": "application/json",
   Accept: "text/plain",
   Authorization: "Basic " + btoa("jonathan.mischke:2_ElefantenHaben4Ohren"),
};
export const host = import.meta.env.PROD ? "" : "http://localhost:8080";

export const aiOptions = {
   models: {
      "mistral-medium-latest":"Günstig & Schnell & EU: mistral-medium",
      // "claude-haiku-4-5": "Günstig & Schnell: claude-haiku-4-5",
      "claude-sonnet-4-6": "Beste Preis/Leistung claude-sonnet-4-6",
      "claude-sonnet-5": "Beste Preis/Leistung, langsamer claude-sonnet-5",
      "claude-opus-4-8": "Beste Leistung, langsam & teurer claude-opus-4-8",
      "claude-opus-5": "Beste Leistung, langsam & teurer claude-opus-5",
   },
   creativityLevel: { 0.3: "sehr wenig", 0.5: "wenig", 0.7: "ausgeglichen", 0.8: "viel", 0.9: "maximal" },
   tokenLevel: { 500: "kurz", 1000: "mittel", 2000: "lang" },
};
export const fieldDependencies = {
   estate: {
      objekttyp: "objektart",
      status2: "status",
   },
   address: {},
};

export const oOSharepointFoldername = "ind_3192_Feld_ObjIndividualCategoryFields295";
export const oOEstateData = "ind_3130_Feld_ObjIndividualCategoryFields361";
export const oOOldCRMLink = "ind_3328_Feld_ObjIndividualCategoryFields303";
export const oOJSONFeldname = "ind_3130_Feld_ObjIndividualCategoryFields361";

export const fieldTypes = {
   currency: "Preis",
   text: "Einzeiler",
   select: "Auswahlfeld",
   // ooSelect: "onOffice-Auswahlfeld",
   // ooMulti: "onOffice-Mehrfachauswahl",
   date: "Datum",
   datetime: "Datum mit Zeit",
   // link: "Link",
   textarea: "Textfeld",
   user: "Nutzerauswahl",
   number: "Nummer",
   // teamsbutton: "Teams-Button",
   // oouser: "oO Benutzerauswahl"
};

export const notizfarben = {
   /* Allgemein: "#39766c",
   Besichtigung: "#8fa82d",
   Bewertung: "#50a",
   Expose: "#348799",
   Notar: "#e1477e",
   Rechnungsstellung: "#4eb38a",
   Fotografie: */
   /* Allgemein: "#265149",
   Besichtigung: "#60721E",
   Bewertung: "#440088",
   Expose: "#225E6B",
   Notar: "#B02E5A",
   Rechnungsstellung: "#2E7A5A",
   Fotografie: "#BC5215",
   a: "#1A3A6D",
   b: "#5D3A1A",
   c: "#343A40", */
   Allgemein: "#734D00",
   Eskalation: "#a06",
   Besichtigung: "#556B00",
   a: "#4B0099",
   Expose: "#005B70",
   Notar: "#990033",
   Rechnungsstellung: "#2E7A5A",
   Fotografie: "#B34700",
   c: "#7A0052",
   b: "#003399",
   Bewertung: "#1B5E53",
};

const distinctColors10 = [
   "#265149", // Dunkles Petrol (basiert auf #39766c)
   "#60721E", // Moosgrün (basiert auf #8fa82d)
   "#440088", // Tiefviolett (basiert auf #50a)
   "#225E6B", // Ozeanblau (basiert auf #348799)
   "#B02E5A", // Beerenrot (basiert auf #e1477e)
   "#2E7A5A", // Smaragd (basiert auf #4eb38a)
   "#BC5215", // Rostorange (Kontrast-Ergänzung)
   "#1A3A6D", // Nachtblau (Kontrast-Ergänzung)
   "#5D3A1A", // Schokoladenbraun (Kontrast-Ergänzung)
   "#343A40", // Anthrazit (Kontrast-Ergänzung)
];

/* fremd_verkauft_vermietet: "Fremd verkauft",
   auftrag_entzogen: "Auftrag entzogen",
   verkauft: "Verkauft", */

export const colorPalette100 = [
   "#003049",
   "#8B0000",
   "#004B23",
   "#480CA8",
   "#BC6C25",
   "#006D77",
   "#212529",
   "#B22222",
   "#023E8A",
   "#2D6A4F",
   "#7209B7",
   "#8B4513",
   "#005F73",
   "#343A40",
   "#E63946",
   "#191970",
   "#006400",
   "#5E548E",
   "#A52A2A",
   "#0A9396",

   // 21-40: Tiefe Zwischentöne
   "#495057",
   "#9A031E",
   "#0077B6",
   "#386641",
   "#800080",
   "#D62828",
   "#206A5D",
   "#3D5A80",
   "#1A4301",
   "#AD2E24",
   "#5E0B15",
   "#001D3D",
   "#2D00F7",
   "#1B4332",
   "#41122C",
   "#9B2226",
   "#03045E",
   "#081C15",
   "#510042",
   "#603808",

   // 41-60: Erd- und Schlammtöne (funktioniert super mit Weiß)
   "#124E52",
   "#902923",
   "#2F3E46",
   "#6D597A",
   "#354F52",
   "#4E5968",
   "#52796F",
   "#31572C",
   "#641220",
   "#432818",
   "#3E5C76",
   "#740938",
   "#102C57",
   "#16423C",
   "#4F6F52",
   "#704214",
   "#3C3633",
   "#282120",
   "#433D8B",
   "#2D4263",

   // 61-80: Beeren, Wein und Nachtblau
   "#541675",
   "#2C3333",
   "#395B64",
   "#04293A",
   "#041C32",
   "#064635",
   "#541212",
   "#80471C",
   "#1E5128",
   "#191A19",
   "#4E31AA",
   "#3A1078",
   "#2F58CD",
   "#37306B",
   "#66347F",
   "#9E4784",
   "#545B77",
   "#374259",
   "#5C469C",
   "#1D267D",

   // 81-100: Gedeckte dunkle Vielfalt
   "#0C134F",
   "#31304D",
   "#161A30",
   "#3E3232",
   "#1B1A55",
   "#070F2B",
   "#1A1A1B",
   "#2C3639",
   "#3F4E4F",
   "#222831",
   "#393E46",
   "#40513B",
   "#609966",
   "#40514E",
   "#2C3333",
   "#1A120B",
   "#3C2A21",
   "#4F200D",
   "#394867",
   "#212A3E",
];

export const statusfarben = {
   4: "#190",
   3: "#90f",
   2: "#5cb",
   1: "#fd0",
   0: "#0001",
   // 9: "#e00",
   "-1": "#e00",
};
export const statusfarbentext = {
   4: "#fff",
   3: "#fff",
   2: "#fff",
   1: "#000",
   0: "#000",
   // 9: "#fff",
   "-1": "#fff",
};

export const localCache = {
   veranstaltungsdatum: "veranstaltungsdat",
   build: "build",
   expDate: "staticDataExp",
   estatekacheln: "kacheln",
   userData: "oOuserData",
   fieldConfig: "oOfieldConfiguration",
   akquiseListe: "akquiseListe",
};

export const eskalationsLevel = 2;

export const notizarten = [
   { name: "Kommentar", value: "Allgemein" },
   { name: "Eskalationsverschiebung", value: "Eskalation" },
   { name: "Bewertung", value: "Bewertung" },
   { name: "Besichtigung", value: "Besichtigung" },
   { name: "Fotografie", value: "Fotografie" },
   { name: "Exposé", value: "Expose" },
   { name: "Notar", value: "Notar" },
   { name: "Rechnungsstellung", value: "Rechnungsstellung" },
];
export const notiznamen = {
   Allgemein: "Kommentar",
   Eskalation: "Eskalationsverschiebung",
   Bewertung: "Bewertung",
   Besichtigung: "Besichtigung",
   Fotografie: "Fotografie",
   Expose: "Expose",
   Notar: "Notar",
   Rechnungsstellung: "Rechnungsstellung",
};

export const terminArten = {
   "Einkaufstermin neu": { kuerzel: "ET neu" },
   "Einkaufstermin Übergabe Bewertungsmappe": {
      kuerzel: "ET BM-Ü",
   },
   Besichtigung: { kuerzel: "BS" },
   "Besichtigung bestätigt": { kuerzel: "BS best" },
   Notartermin: { kuerzel: "NT" },
};

export const terminArtenEinkauf = ["Einkaufstermin neu", "Einkaufstermin Übergabe Bewertungsmappe"];

export const terminArtenVerkauf = ["Besichtigung", "Besichtigung bestätigt", "Notartermin"];

export const datenanforderKacheln2 = [
   "grundbuch",
   "brandversicherung",
   "feuerstattenbescheid",
   "grundsteuerbescheid",
   "altlast",
   "baulast",
   "erschliessung",
   "mietvertraege",
   "",
   "",
];
export const datenanforderKacheln = {
   grundbuch: "abgb",
   brandversicherung: "abbv",
   feuerstattenbescheid: "abfs",
   grundsteuerbescheid: "abgs",
   altlast: "abal",
   baulast: "abbl",
   erschliessung: "abes",
   mietvertraege: "abmv",
   teilungsErklarung: "abtl",
   Aufteilungsplane: "abatp",
   bauunterlag_haus_grund: "abhg",
   bauunterlag_whg_wohnfl: "abwf",
   abrechnung: "abuar",
   sitzungsprotokolle: "abusp",
   beschlusssammlungen: "abubs",
   hausordnung: "abuho",
   sanierungsvermerk: "absv",
   denkmalschutz: "abdm",
};

export const fotoStapelKacheln = {
   ft_innen: "fin",
   ft_aussen: "fau",
   ft_drohne: "fdr",
   ft_matterport: "fmp",
   ft_ogulo: "fog",
   ft_reel: "frl",
};

export const initialKachelFilter = {
   datenblatt: ["NachtragDB"],
   einkaufstermin: ["NachtragBT"],
   bewertungsbestellung: ["NachtragBB"],
   bewertungsergebnis: ["NachtragBE"],
   vorankuendigung: ["NachtragVA"],
   vollmacht: ["NachtragVM"],
   expobildererstellen: ["NachtragEB"],
   expogrundriss: ["NachtragEG", "NachtragEG2", "NachtragEG3"],
   expotext: ["NachtragET"],
   expoerstellung: ["NachtragEE", "NachtragEE2", "NachtragEE3", "NachtragEE4", "NachtragEE5"],
   exponachtrag: [
      "expo_nachtrag2",
      "expo_nachtrag3",
      "expo_nachtrag4",
      "expo_nachtrag5",
      "expo_nachtrag6",
      "expo_nachtrag7",
      "expo_nachtrag8",
      "expo_nachtrag9",
   ],
   energieausweis: ["NachtragEA"],
   aufbereitung: ["NachtragAB", "NachtragAB2", "NachtragAB3", "NachtragAB4", "NachtragAB5", "NachtragAB6"],
   kaufabwicklung: ["NachtragKA"],
};

export const Einkaufer = {
   BBaur: "",
   DLinkh: "",
   CHalder: "",
   LSchroeder: "",
   TSchimminger: "",
   CMollis: "",
   NKonzack: "",
   DFreitag: "",
   MSauter: "",
   PMoldenhauer: "",
   MGaum: "",
   EigentuemerNeu: "",
};

export const fi = {
   kaufpreis: "kaufpreis",
   provAussen: "aussen_courtage",
   provInnen: "innen_courtage",
   provPausVK: "ind_2214_Feld_ObjPreise68",
   provPausAK: "ind_2754_Feld_ObjPreise303",
};

export const fo = {};
